import { FiDownload } from "react-icons/fi";
import DraggableScrollableList from "../components/draggableList";
import ScrollContainer from "react-indiana-drag-scroll";
import { retrunAssets } from "../utils/getAssets";
import { PropTypes } from 'prop-types';
const PastAnnualReports = ({ events }) => {


    const title = events?.pastAnnualReportsTitle

    const reports = events?.annualReports?.items.map((report) => {
        report = report?.content?.properties
        return {
            img: report?.coverImage != null ? retrunAssets(report?.coverImage[0]?.url) : "",
            text: report?.title,
            link: report?.externalLink
        }
    }
    )

    return (
        <div className="py-8">
            <div className="relative bg-white  text-black w-full p-6 md:px-32 flex flex-col items-center justify-center">
                <div className="flex relative items-stretch justify-between  w-full">
                    <h1 className="text-red-500 text-2xl font-semibold border-b-2 border-red-500 py-3">{title}</h1>
                    <div className="flex-1 w-full flex items-center justify-end border-b-2 border-b-neutral-700 py-3">
                        <div className="flex items-center gap-3  select-none font-bold">
                            <div className="w-12 h-12 flex items-center justify-center rounded-full border-2 border-neutral-950 ">
                                <FiDownload size={30} />
                            </div>
                            <span className="uppercase font-extrabold">Latest Annual Report</span>
                        </div>
                    </div>
                </div>

            </div>
            <ScrollContainer horizontal className="flex px-32 gap-5 w-full   scroll-smooth snap-mandatory snap-x overflow-x-auto scroll-px-3 p-2 mt-2 ">
                {
                    reports?.map((report, index) => (
                        <div key={index} className="w-[21rem] flex shrink-0 snap-center relative items-center justify-between gap-4 py-4 ">
                            <div className="flex w-full flex-col items-start gap-4">
                                <div className="w-full h-[25rem] bg-cover bg-center bg-no-repeat" style={{ backgroundImage: `url('${report?.img}')` }}></div>
                                <a href={report?.link}  target="_blank" rel='noreferrer' className="text-sm text-cyan-600 font-bold hover:underline">{report?.text}</a>
                            </div>
                        </div>
                    ))
                }
            </ScrollContainer>

        </div>
    )
}
PastAnnualReports.propTypes = {
    events: PropTypes.object
}
export default PastAnnualReports